<template>
  <div class= "about-page">

   <div class = "img-rotes-header">
     <p class = "aboutss" style = "font-size: 30px;"> QF Facilities</p>
      <p class = "aboutss">


        QF is a facility management software that connect tenants to facility management real-time via chat window, video and picture upload enabler.
        </p>
        <br />

    </div>
     <div class = "sanwo-content">

    <p style="color: #000">
     
      It also connects facility management to tenants, vendor and maintenance team. 
      Lastly the software connects facility supervisors to management by offering facility audit and real-time reporting.


      </p>



                      <router-link :to="{ name: 'Contact' }">

         <a class="btn btn-new btn-xl js-scroll-trigger" href="#services"
                style = "background-color: #A31B1F ; color : #FFFFFF"
                
                >Learn more</a
              > 
                      </router-link>
        
    </div>

</div>
</template>

<style>
.about-page {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.about{
display: flex;
  align-items: center;
  justify-content: center;
font: normal normal normal 24px/35px Prompt;font: normal normal normal 26px/45px Prompt;
font-weight: bold;
width: 50vw;
letter-spacing: 0px;
color: #FFFFFF;
opacity: 1;
}
#para {
  color: #2D2D2D
}
.brand-area {
        display: flex;
        justify-content: center;
    }
.img-rotes-header {
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 45px;
  justify-content: center;
  align-items: center;
  height: 700px;    
  background-attachment: fixed;
  background-position: center; 
  position: relative;
  background-repeat: no-repeat;
  background: linear-gradient( rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6) ), url('../assets/img/Rotes.png'); 
      background-size: cover;

}

.mission{
  width: 450px;
  padding: 15px;
  color: #2D2D2D;
  font-size: 16px;
  height:   200px;
  background: #FFFFFF 0% 0% no-repeat padding-box;
box-shadow: 0px 8px 24px #0000000D;
border-radius: 15px;
opacity: 1;
display: flex;
align-items: center;
flex-direction: column;
justify-content: center;

}
.business{
  display: flex;
  align-items: center;
  justify-content: center;
  width: 280px;
  padding: 70px;
  color: #2D2D2D;
  font-size: 16px;
  background: #FFFFFF 0% 0% no-repeat padding-box;
box-shadow: 0px 8px 24px #0000000D;
border-radius: 15px;
opacity: 1;
height: 185px;
text-align: center;

}

.touch{
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: 15px;
  width: 90vw;
  color: #2D2D2D;
  font-size: 16px;
  background: #FFFFFF 0% 0% no-repeat padding-box;
box-shadow: 0px 8px 24px #0000000D;
border-radius: 15px;
opacity: 1;
height: 185px;
text-align: center;

}

footer {
  width:100vw
}
body {
  background: black;
}
</style>

<script>
    import router from '../router'

    export default {
        name: 'Rotes',
        methods: {
            navigate() {
                router.push({ name: "Rotes" });
            }
        }
    }
</script>

